module.exports = __webpack_public_path__ + "img/17395A_7EBCC7_4D8B9F_65A1B5-256px.c4a5c665.png";